/*
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { AbilityService } from "../../ability/AbilityService";
import { useEditorMainContext } from "../contexts/EditorMainContext";

export function useAbility(): AbilityService {
	return useEditorMainContext()?.abilityService;
}
